var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-container" },
    _vm._l(_vm.items, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          class: ["item", { active: item.active }],
          on: {
            click: function($event) {
              return _vm.onClick($event, item.value)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "outer-icon" },
            _vm._l(item.imgs, function(img, imgIndex) {
              return _c("img", {
                key: imgIndex,
                style: img.style,
                attrs: { src: img.src }
              })
            }),
            0
          ),
          _vm._v(" "),
          item.active
            ? _c("i", { staticClass: "fas fa-dot-circle" })
            : _c("i", { staticClass: "far fa-circle" })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8169a68a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8169a68a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseRadioPaymentMethod.vue
// module id = null
// module chunks = 